//load sinle team css
import './../../css/about-single.scss';
import './../../index';

  //initialize the team
  const urlParams = new URLSearchParams(window.location.search);
  const slug = urlParams.get('team');
  const pathname = window.location.pathname.substring(window.location.pathname.replace(/\/$/, '').lastIndexOf('/') + 1).replace(/\/$/, '');
  import(
    /* webpackMode: "lazy" */
    /* webpackChunkName: "about-team/list" */
    './../../components/team/team.js'
  ).then(teamService => {
    var team = new teamService.default();
    team.setDiv("mrsTeam");
    if(pathname != '' && pathname != 'single.html') {
      team.getTeam(pathname);
    } else if(slug) {
      team.getTeam(slug);
    }
  });
